import ACTION_TYPES from '../../constants/actionTypes';

const reducers = {
  authToken(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.MAGIC_LINK_SIGN_IN_SUCCESS:
      case ACTION_TYPES.SIGN_IN_SUCCESS:
      case ACTION_TYPES.SIGN_UP_SUCCESS:
        return action.payload.auth.token;
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  isAuthInProgress(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.SIGN_IN:
      case ACTION_TYPES.SIGN_UP:
      case ACTION_TYPES.SEND_RESET_PASSWORD_EMAIL:
      case ACTION_TYPES.RESET_PASSWORD:
        return true;
      case ACTION_TYPES.SIGN_IN_SUCCESS:
      case ACTION_TYPES.SIGN_IN_FAILURE:
      case ACTION_TYPES.SIGN_UP_SUCCESS:
      case ACTION_TYPES.SIGN_UP_FAILURE:
      case ACTION_TYPES.SIGN_OUT:
      case ACTION_TYPES.RESET_PASSWORD_SUCCESS:
      case ACTION_TYPES.RESET_PASSWORD_FAILURE:
        return false;
      default:
        return state;
    }
  },
};

export default reducers;
